import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import {
  GetAllMisc,
  getGPUsbyStoreCompanyStatus,
  getGPUsOrderbyStore,
  getWaterBlockbyStore,
  UnassembleGpuApi,
  UnassignGpuApi,
} from "../../api";
import { Header, Button } from "../../components";
import "../../styles/viewCustomer.css";
import { useStateContext } from "../../contexts/ContextProvider";
import { Col, Container, Row } from "react-bootstrap";
import { usePromiseTracker, trackPromise } from "react-promise-tracker";
import {
  showSuccessToast,
  showInfoToast,
  showErrorToast,
} from "../../components/ToastMesg";
import SelectFilter from "../../components/SelectFilter";
import DataGrid from "../../components/DataGrid";

const GpuWb = () => {
  const navigate = useNavigate();
  const { userPermID, userID, companyG, storeG } = useStateContext();
  const [getcategories, setCategories] = useState([]);
  const [AllParts, setAllParts] = useState("");
  const [category, setcategory] = useState("");
  const [mode, setMode] = useState("GPU");
  const [rowRec, setRowRec] = useState("");
  const { promiseInProgress } = usePromiseTracker();
  const [loading, setloading] = useState(true);

  const PartGridactiveStatus = (props) => (
    <div className="flex gap-2 justify-center items-center text-white font-bold">
      <label
        className={`py-2 px-2 rounded-2xl ${props.so_status === "Closed" ? "text-gray-800" : props.so_status === "Canceled" ? "text-red-700" : props.so_status === "Hold" ? "text-amber-900" : props.so_status === "Open" ? "text-blue-800" : "text-green-800"}`}
      >
        {props.so_status}
      </label>
    </div>
  );
  const soIdTemp = (props) => (
    <div>{props.so_id ? `S${props.so_id}` : `-`}</div>
  );

  const handleRowSelected = (args) => setRowRec(args.data);

  const ordersGrid = [
    {
      field: "so_id",
      template: soIdTemp,
      headerText: "SO #",
      minWidth: "100",
      width: "110",
      maxWidth: "110",
      textAlign: "Center",
    },
    {
      field: "sale_date",
      headerText: "Sales Date",
      type: "datetime",
      format: "dd/MM/yyyy HH:mm",
      minWidth: "150",
      width: "155",
      maxWidth: "160",
      textAlign: "Center",
    },
    {
      field: "customer",
      headerText: "Customer",
      minWidth: "160",
      width: "180",
      maxWidth: "360",
      textAlign: "left",
    },
    {
      field: "customer_po_no",
      headerText: "Cust PO",
      minWidth: "130",
      width: "140",
      maxWidth: "180",
      textAlign: "left",
    },
    {
      field: "so_status",
      headerText: "Status",
      template: PartGridactiveStatus,
      minWidth: "120",
      width: "120",
      maxWidth: "130",
      textAlign: "left",
    },
    {
      field: "part_number",
      headerText: "Part No",
      minWidth: "125",
      width: "130",
      maxWidth: "140",
      textAlign: "left",
    },
    {
      field: "part_description",
      headerText: "Part Description",
      minWidth: "200",
      width: "360",
      maxWidth: "880",
      textAlign: "left",
    },
    {
      field: "quantity",
      headerText: "Order Qty",
      minWidth: "135",
      width: "140",
      maxWidth: "140",
      textAlign: "right",
    },
    {
      field: "pass_quantity",
      headerText: "Pass Qty",
      minWidth: "130",
      width: "135",
      maxWidth: "140",
      textAlign: "right",
    },
    {
      field: "assemble_quantity",
      headerText: "Assm Qty",
      minWidth: "135",
      width: "140",
      maxWidth: "145",
      textAlign: "right",
    },
    {
      field: "ship_quantity",
      headerText: "Ship Qty",
      minWidth: "125",
      width: "130",
      maxWidth: "135",
      textAlign: "right",
    },
    {
      field: "user_note",
      headerText: "User Note",
      minWidth: "140",
      width: "160",
      maxWidth: "360",
      textAlign: "left",
    },
  ];

  const gpusGrid = [
    {
      field: "gpu_sn",
      headerText: "GPU SN",
      minWidth: "140",
      width: "150",
      maxWidth: "220",
      textAlign: "left",
    },
    {
      field: "name",
      headerText: "GPU Name",
      minWidth: "180",
      width: "280",
      maxWidth: "480",
      textAlign: "left",
    },
    {
      field: "part_number",
      headerText: "GPU PN",
      minWidth: "125",
      width: "130",
      maxWidth: "140",
      textAlign: "left",
    },
    {
      field: "status",
      headerText: "Status",
      minWidth: "120",
      width: "120",
      maxWidth: "130",
      textAlign: "left",
    },
    {
      field: "so_id",
      template: soIdTemp,
      headerText: "SO #",
      minWidth: "100",
      width: "110",
      maxWidth: "110",
      textAlign: "center",
    },
    {
      field: "recv_scan_date",
      headerText: "Recv Date",
      type: "datetime",
      format: "dd/MM/yyyy HH:mm",
      minWidth: "150",
      width: "155",
      maxWidth: "160",
      textAlign: "Center",
    },
    {
      field: "pull_scan_date",
      headerText: "Pull Date",
      type: "datetime",
      format: "dd/MM/yyyy HH:mm",
      minWidth: "150",
      width: "155",
      maxWidth: "160",
      textAlign: "Center",
    },
    {
      field: "test_scan_date",
      headerText: "Test Date",
      type: "datetime",
      format: "dd/MM/yyyy HH:mm",
      minWidth: "150",
      width: "155",
      maxWidth: "160",
      textAlign: "Center",
    },
    {
      field: "sku",
      headerText: "SKU",
      minWidth: "140",
      width: "160",
      maxWidth: "190",
      textAlign: "left",
    },
    {
      field: "lot_no",
      headerText: "Lot No",
      minWidth: "120",
      width: "140",
      maxWidth: "160",
      textAlign: "left",
    },
    {
      field: "box_id",
      headerText: "Box ID",
      minWidth: "120",
      width: "140",
      maxWidth: "160",
      textAlign: "left",
    },
    {
      field: "test_result",
      headerText: "Test Res",
      minWidth: "120",
      width: "140",
      maxWidth: "160",
      textAlign: "left",
    },
  ];

  const wbsGrid = [
    {
      field: "sn",
      headerText: "WB SN",
      minWidth: "160",
      width: "180",
      maxWidth: "220",
      textAlign: "left",
    },
    {
      field: "name",
      headerText: "WB Name",
      minWidth: "180",
      width: "280",
      maxWidth: "480",
      textAlign: "left",
    },
    {
      field: "part_number",
      headerText: "WB PN",
      minWidth: "125",
      width: "130",
      maxWidth: "140",
      textAlign: "left",
    },
    {
      field: "status",
      headerText: "Status",
      minWidth: "120",
      width: "120",
      maxWidth: "130",
      textAlign: "left",
    },
    {
      field: "so_id",
      template: soIdTemp,
      headerText: "SO #",
      minWidth: "100",
      width: "110",
      maxWidth: "110",
      textAlign: "center",
    },
    {
      field: "recv_scan_date",
      headerText: "Recv Date",
      type: "datetime",
      format: "dd/MM/yyyy HH:mm",
      minWidth: "150",
      width: "155",
      maxWidth: "160",
      textAlign: "Center",
    },
    {
      field: "pull_scan_date",
      headerText: "Pull Date",
      type: "datetime",
      format: "dd/MM/yyyy HH:mm",
      minWidth: "150",
      width: "155",
      maxWidth: "160",
      textAlign: "Center",
    },
    {
      field: "prod_date",
      headerText: "Prod Date",
      type: "date",
      format: "dd/MM/yyyy",
      minWidth: "130",
      width: "145",
      maxWidth: "150",
      textAlign: "Center",
    },
    {
      field: "id_no_1",
      headerText: "ZOOX ID No",
      minWidth: "140",
      width: "160",
      maxWidth: "190",
      textAlign: "left",
    },
    {
      field: "id_no_2",
      headerText: "PNY ID No",
      minWidth: "140",
      width: "160",
      maxWidth: "190",
      textAlign: "left",
    },
    {
      field: "test_result",
      headerText: "Test Res",
      minWidth: "120",
      width: "140",
      maxWidth: "160",
      textAlign: "left",
    },
  ];

  const handleRecGpuClick = () => {
    TimeoutUtility.resetTimeout();
    if (
      rowRec?.gpu_id &&
      window.confirm(`Do you want to edit the selected GPU?`)
    )
      navigate(`/GpuWb/EditGpu/${rowRec.gpu_id}`);
    else navigate("/GpuWb/ReceiveGpu");
  };

  const handleRecvWbClick = () => {
    TimeoutUtility.resetTimeout();
    navigate("/GpuWb/ReceiveWb");
  };

  const handleIWbClick = () => {
    TimeoutUtility.resetTimeout();
    navigate("/GpuWb/ImportWb");
  };

  const handleTstClick = () => {
    TimeoutUtility.resetTimeout();
    if (rowRec?.so_id) navigate(`/GpuWb/TestGPU/${rowRec.so_id}`);
    else showInfoToast("Info!", "Please select work order!");
  };

  const handleUnasinClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    if (rowRec?.gpu_id) {
      if (
        window.confirm(`Are you sure you want unassign '${rowRec.gpu_sn}' GPU?`)
      ) {
        const resp = await UnassignGpuApi(rowRec.gpu_id, userID);
        if (resp.success)
          showSuccessToast("Success!", "GPU Unassigned successfully.");
        else {
          showErrorToast("Error!", "Failed to Unassign GPU!\n" + resp.message);
          return;
        }
        setTimeout(function () {
          window.location.reload();
        }, 1000);
      }
    } else showInfoToast("Info!", "Please select GPU!");
  };

  const handleCAsClick = () => {
    TimeoutUtility.resetTimeout();
    navigate("/GpuWb/CreateAssembly");
  };

  const handleTAssyClick = () => {
    TimeoutUtility.resetTimeout();
    navigate("/GpuWb/TestGpuAssembly");
  };

  const handleUnasClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    if (rowRec?.gpu_id) {
      if (
        window.confirm(
          `Are you sure you want to unassemble '${rowRec.gpu_sn}' GPU?`,
        )
      ) {
        const resp = await UnassembleGpuApi(rowRec.gpu_id, userID);
        if (resp.success)
          showSuccessToast("Success!", "GPU Unassembled successfully.");
        else {
          showErrorToast(
            "Error!",
            "Failed to unassemble GPU!\n" + resp.message,
          );
          return;
        }
        setTimeout(function () {
          window.location.reload();
        }, 1000);
      }
    } else showInfoToast("Info!", "Please select GPU!");
  };

  const handleShpClick = () => {
    TimeoutUtility.resetTimeout();
    if (rowRec?.so_id) navigate(`/GpuWb/ShipAssembly/${rowRec.so_id}`);
    else showInfoToast("Info!", "Please select work order!");
  };

  const handleViwClick = () => {
    TimeoutUtility.resetTimeout();
    if (rowRec?.so_id) navigate(`/GpuWb/ViewAssembly/${rowRec.so_id}`);
    else showInfoToast("Info!", "Please select work order!");
  };

  const handleHistClick = () => {
    TimeoutUtility.resetTimeout();
    if (rowRec?.gpu_id) navigate(`/GpuWb/ViewGpuHistory/${rowRec.gpu_id}`);
    else showInfoToast("Info!", "Please select GPU!");
  };

  const handleRMAClick = () => {
    TimeoutUtility.resetTimeout();
    navigate(`/GpuWb/GpuRMA`);
  };

  const handleReportClick = () => {
    TimeoutUtility.resetTimeout();
    navigate("/GpuWb/Report");
  };

  const handleChangeCategory = (option) => {
    TimeoutUtility.resetTimeout();
    if (option && option.value) setcategory(option);
    else setcategory("select");
  };

  useEffect(() => {
    async function fetchData() {
      if (companyG !== null && storeG && companyG.company_id !== 0) {
        let cmp_id = companyG.company_id;
        let str_id = storeG.store_id;
        let ctg_id = null;
        if (category !== "select" && category !== "") ctg_id = category.value;
        setloading(true);
        if (mode === "GPU")
          trackPromise(
            getGPUsbyStoreCompanyStatus(str_id, cmp_id, ctg_id)
              .then((productsResponse) => setAllParts(productsResponse.data))
              .catch((error) => console.error("Error fetching data:", error))
              .finally(() => setloading(false)),
          );
        else if (mode === "WB")
          trackPromise(
            getWaterBlockbyStore(str_id, cmp_id)
              .then((productsResponse) => setAllParts(productsResponse.data))
              .catch((error) => console.error("Error fetching data:", error))
              .finally(() => setloading(false)),
          );
        else if (mode === "WO")
          trackPromise(
            getGPUsOrderbyStore(str_id, cmp_id)
              .then((productsResponse) => setAllParts(productsResponse.data))
              .catch((error) => console.error("Error fetching data:", error))
              .finally(() => setloading(false)),
          );
      }
    }
    fetchData();
  }, [category, companyG, storeG, mode]);

  const handleRefresh = async () => {
    if (companyG !== null && storeG && companyG.company_id !== 0) {
      let cmp_id = companyG.company_id;
      let str_id = storeG.store_id;
      let ctg_id = null;
      if (mode === "GPU") {
        if (category !== "select" && category !== "") ctg_id = category.value;
        const resp = await getGPUsbyStoreCompanyStatus(str_id, cmp_id, ctg_id);
        setAllParts(resp.data || []);
      } else if (mode === "WB") {
        const resp = await getWaterBlockbyStore(str_id, cmp_id);
        setAllParts(resp.data || []);
      } else if (mode === "WO") {
        const resp = await getGPUsOrderbyStore(str_id, cmp_id);
        setAllParts(resp.data || []);
      }
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      TimeoutUtility.resetTimeout();
      await GetAllMisc("gpuwb/gpustatus")
        .then((resp) => {
          const typeOptions = resp.data.map((item) => ({
            label: item.name,
            value: item.status_id,
          }));
          setCategories(typeOptions || []);
        })
        .catch((err) => console.log(err.message));
    };
    fetchData();
  }, []);

  return (
    <div>
      <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
        <Row>
          <Col xl={3} md={4}>
            <Header
              category="Stock"
              title={
                mode === "GPU"
                  ? "GPUs"
                  : mode === "WB"
                    ? "Water Blocks"
                    : "Work Orders"
              }
            />
          </Col>
          <Col xl={6} md={4} className="text-center">
            <Header title={companyG.name} />
          </Col>
          <Col xl={3} md={4}>
            <label className="font-bold mr-2">GPU View: </label>
            <input
              type="radio"
              name="mode"
              checked={mode === "GPU"}
              style={{ width: "16px", height: "16px" }}
              onChange={() => setMode("GPU")}
            />
            <br />
            <label className="font-bold mr-2">WB View: </label>
            <input
              type="radio"
              name="mode"
              checked={mode === "WB"}
              style={{ width: "16px", height: "16px" }}
              onChange={() => setMode("WB")}
            />
            <br />
            <label className="font-bold mr-2">Order View: </label>
            <input
              type="radio"
              name="mode"
              checked={mode === "WO"}
              style={{ width: "16px", height: "16px" }}
              onChange={() => setMode("WO")}
            />
          </Col>
        </Row>
        <Container fluid className="g-0 p-0 justify-end">
          <Row xs={2} className="button-row justify-content-end font-normal">
            {userPermID.includes(54) && (
              <>
                {mode === "GPU" && (
                  <Col md="auto p-0">
                    <Button text="Recv/Edit GPUs" onClick={handleRecGpuClick} />
                  </Col>
                )}
                {mode === "WB" && (
                  <>
                    <Col md="auto p-0">
                      <Button text="Recv WBs" onClick={handleRecvWbClick} />
                    </Col>
                    <Col md="auto p-0">
                      <Button text="Import Recv WBs" onClick={handleIWbClick} />
                    </Col>
                  </>
                )}
              </>
            )}
            {userPermID.includes(55) && (
              <>
                {mode === "WO" && (
                  <Col md="auto p-0">
                    <Button text="Assign & Test GPU" onClick={handleTstClick} />
                  </Col>
                )}
                {mode === "GPU" && (
                  <>
                    <Col md="auto p-0">
                      <Button text="Unassign GPU" onClick={handleUnasinClick} />
                    </Col>
                    <Col md="auto p-0">
                      <Button text="View History" onClick={handleHistClick} />
                    </Col>
                    <Col md="auto p-0">
                      <Button text="GPU RMA Form" onClick={handleRMAClick} />
                    </Col>
                    <Col md="auto p-0">
                      <Button text="Unassemble GPU" onClick={handleUnasClick} />
                    </Col>
                  </>
                )}
                {(mode === "WO" || mode === "GPU") && (
                  <Col md="auto p-0">
                    <Button text="Create Assemblies" onClick={handleCAsClick} />
                  </Col>
                )}
                {(mode === "WO" || mode === "GPU") && (
                  <Col md="auto p-0">
                    <Button text="Test Assemblies" onClick={handleTAssyClick} />
                  </Col>
                )}
                {mode === "WO" && (
                  <>
                    <Col md="auto p-0">
                      <Button text="Ship Assemblies" onClick={handleShpClick} />
                    </Col>
                    <Col md="auto p-0">
                      <Button text="View Assemblies" onClick={handleViwClick} />
                    </Col>
                  </>
                )}
                <Col md="auto p-0">
                  <Button text="Reports" onClick={handleReportClick} />
                </Col>
              </>
            )}
            {mode === "GPU" && (
              <Col md="auto p-0">
                <SelectFilter
                  value={category}
                  options={getcategories}
                  onChange={handleChangeCategory}
                  placeholder="Select Status"
                />
              </Col>
            )}
          </Row>
        </Container>
        <DataGrid
          loading={loading || promiseInProgress}
          data={AllParts}
          cols={
            mode === "GPU" ? gpusGrid : mode === "WB" ? wbsGrid : ordersGrid
          }
          handleRowSelected={handleRowSelected}
          handleDoubleClick={
            mode === "GPU" && userPermID.includes(53) && handleHistClick
          }
          persistant={false}
          handleRefresh={handleRefresh}
        />
      </div>
    </div>
  );
};

export default GpuWb;
